module.exports = __webpack_public_path__ + "static/bnr_wide@3x-4277228983a000980d0c9885207fe2d8.webp";